import { apiClient } from '@jobcost-monorepo/utils';
import FinancialReportdHeader from './Header';
import { BASE_URL, MN_TIMESHEET } from '@jobcost-monorepo/crud';
import { useState } from 'react';
import { IFinancialReport } from './types';
import FinancialReportBody from './Body';

export default function FinancialReportPage() {
  const [groupedData, setGroupedData] = useState<IFinancialReport[]>([]);
  const handleSearch = async (
    startDate: string,
    endDate: string,
    resourceId?: number,
    orderId?: number,
    customerId?: number,
    jobId?: number,
  ) => {
    const response = await apiClient.get<IFinancialReport[]>({
      url: `${BASE_URL}/${MN_TIMESHEET.toLowerCase()}/reportFinancialRevenue`,
      params: { startDate, endDate, resourceId, orderId, customerId, jobId },
    });
    if (response.data) {
      setGroupedData(response.data);
    }
  };

  return (
    <div className="flex flex-col size-full">
      <div className="px-6 pt-6">
        <FinancialReportdHeader handleSearch={handleSearch} />
      </div>
      <div className="overflow-auto px-6 pt-6">
        <FinancialReportBody dataList={groupedData} />
      </div>
    </div>
  );
}
